import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { SECTIONS } from "@/pages/portal/event-space/shared";

/** Submenu of the event currently open, nested under the "Événements" sidebar item. */
export default function EventSpaceNav({ onNavigate }) {
  const loc = useLocation();
  const slug = (loc.pathname.match(/^\/portal\/event\/([^/]+)/) || [])[1];
  const [spaces, setSpaces] = useState([]);

  useEffect(() => {
    const load = () => api.get("/my/event-spaces").then((r) => setSpaces(r.data || [])).catch(() => {});
    load();
    window.addEventListener("event-spaces:refresh", load);
    return () => window.removeEventListener("event-spaces:refresh", load);
  }, []);

  const [fallback, setFallback] = useState({});
  const s = spaces.find((x) => x.slug === slug);
  useEffect(() => {
    if (slug && !s && !fallback[slug]) api.get(`/event-space/${slug}`).then((r) => setFallback((f) => ({ ...f, [slug]: r.data.event?.title }))).catch(() => {});
  }, [slug, s, fallback]);
  if (!slug) return null;
  return (
    <div className="ml-5 mt-0.5 border-l-2 border-wine-100 pl-2" data-testid="event-space-nav">
      <div className="truncate px-2.5 pb-1 pt-1.5 text-[11px] font-bold text-navy" title={s?.title} data-testid="event-space-nav-title">{s?.title || fallback[slug] || "Mon événement"}</div>
      {SECTIONS.map((sec) => (
        <NavLink key={sec.id} to={`/portal/event/${slug}/${sec.id}`} onClick={onNavigate}
          className={({ isActive }) => `flex items-center gap-2 rounded-lg px-2.5 py-1.5 text-[12.5px] font-medium transition-colors ${isActive ? "bg-wine-50 text-wine-700" : "text-neutral-600 hover:bg-wine-50/50 hover:text-wine-700"}`}
          data-testid={`event-space-link-${slug}-${sec.id}`}>
          <sec.icon className="h-3.5 w-3.5" />{sec.label}
        </NavLink>
      ))}
    </div>
  );
}
